module.exports = __webpack_public_path__ + "static/media/speech_19.a68bee36.svg";